<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-24 09:11:38
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-02-14 14:16:44
-->
<template>
  <div v-show="isShow">
    <config-item :label="label">
      <div class="flex flex-nowrap row-right">
        <div
          v-for="(item, index) in tagList"
          :key="index"
          @click="clickItem(item)"
          :class="[item.value == value.status ? 'mode-select-item-active' : '']"
          class="mode-select-item flex-center"
        >
          <span>{{ item.label }}</span>
        </div>
      </div>
    </config-item>

    <div class="select-label" v-show="value.status != 'hide'">
      <span class="select-label-text" style="width: 100px">背景颜色</span>
      <span class="select-label-text" style="margin-left: 24px">{{
        value.color
      }}</span>
      <config-color-picker
        v-model="value.color"
        :mOptions="mOptions.color"
        cate="view"
      ></config-color-picker>
    </div>

    <config-item label="图片" v-show="value.status == 'image'">
      <div class="flex flex-nowrap row-right">
        <SchemaUpload label="" v-model="value.url" />
      </div>
    </config-item>

    <config-item label="图片缩放" v-show="value.status == 'image'">
      <div class="flex flex-nowrap row-right">
        <el-select
          v-model="value.zoom"
          placeholder="请选择"
          size="small"
          style="width: 75%"
        >
          <el-option
            v-for="item in list"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </config-item>
  </div>
</template>

<script>
import schemaMixin from "@/mixin/schemaMixin";
import ConfigColorPicker from "@/custom-schema-template/components/SchemaColor/ConfigColorPicker";

export default {
  name: "SchemaBackSetting",
  mixins: [schemaMixin],
  inject: ["mode"],
  components: {
    ConfigColorPicker,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: {},
    },
    isShow: {
      default: true,
    },
  },
  data() {
    return {
      tagList: [
        { label: "隐藏", value: "hide" },
        { label: "颜色填充", value: "color" },
        { label: "图片", value: "image" },
      ],
      list: [
        { label: "填充", value: "cover" },
        { label: "等比例", value: "contain" },
        { label: "平铺", value: "repeat" },
        { label: "拉伸", value: "stretch" },
        { label: "原图", value: "artwork" },
      ],
    };
  },
  watch: {
    mValue: {
      immediate: true,
      deep: true,
      handler(newValue) {},
    },
  },
  methods: {
    clickItem(data) {
      this.$set(this.value, 'status', data.value);
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/variable";

.mode-select-item {
  padding: 8px 10px;
  min-width: 55px;
  border: 1px solid #dcdee0;
  /*no*/
  border-radius: 0;
  font-size: 12px;
  /*no*/
  font-weight: 500;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: $color-theme;
    border-color: $color-theme;
    background-color: #e0edff;

    i {
      color: $color-theme;
    }
  }

  i {
    color: #979797;
  }
}

.mode-select-item-active {
  color: $color-theme;
  border-color: $color-theme;
  background-color: #e0edff;

  i {
    color: $color-theme;
  }
}

.select-label {
  margin: 0 27px 0 10px;
  display: flex;
  align-items: center;

  .select-label-text {
    color: #969799;
    font-size: 13px;
  }
}
</style>
